import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const ciscoCdets = defineConnector({
  identifier: "ciscoCdets",
  name: "Cisco CDETS",
  tagLine: "Defect tracking system",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ host }) => domainToRegex(host),
  auth: customAuth("oauth1HmacSha1"),
  steps: [
    {
      title: "Create OAuth credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to [COAR](https://stage-coar.cisco.com) and issue an OAuth 1.0 consumer key/secret and token key/secret for CDETS. You’ll need all four values.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "API host",
          required: true,
          placeholder: "cdets.cisco.com",
          helperText: "Hostname of your CDETS API endpoint.",
          target: { kind: "configuration", field: "host" },
        },
        {
          kind: "input",
          label: "Consumer key",
          required: true,
          target: { kind: "secrets", field: "consumerKey" },
        },
        {
          kind: "input",
          label: "Consumer secret",
          required: true,
          target: { kind: "secrets", field: "consumerSecret" },
        },
        {
          kind: "input",
          label: "Token key",
          required: true,
          target: { kind: "secrets", field: "tokenKey" },
        },
        {
          kind: "input",
          label: "Token secret",
          required: true,
          target: { kind: "secrets", field: "tokenSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => ({
      url: `https://${host}/`,
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }),
  },
});
